import { facilitate } from "./components/homePage/facilitate";
import { footer } from "./components/footer";
import { hero } from "./components/homePage/hero";
// import { ibankeyBridge } from "./components/homePage/ibankeyBridge";
import { navbar } from "./components/navbar";
import { scheme } from "./components/homePage/scheme";
import { whyIbankey } from "./components/homePage/why";
import "./index.css";
import { weOffers } from "./components/homePage/weOffers";
import { smeChamber } from "./components/homePage/smechamber";

document.querySelector("#root")!.innerHTML =
  navbar +
  hero +
  weOffers +
  smeChamber +
  whyIbankey +
  facilitate +
  scheme +
  footer;

const Scrollnavbar = document.getElementById("navbar");

window.addEventListener("scroll", () => {
  if (window.scrollY > 10) {
    //@ts-ignore
    Scrollnavbar.classList.add("shadow-md", "bg-white");
  } else {
    //@ts-ignore
    Scrollnavbar.classList.remove("shadow-md");
  }
});
const schems = [
  {
    loanSchemeId: "076BA633-AF91-402E-BC01-FB1C2B5EBA71",
    schemeCode: "Others",
    schemeDescription: "Default options",
    schemeDetails: "All loan types will be available.",
    iconURL: null,
    govtWebSite: "",
    isDefailt: true,
    key_takeaways:
      '["Collateral-free credit","Government-backed initiative","Boosts financial inclusion for MSMEs"]',
    sortOrder: 0,
    limit: 50000000000.0,
  },
  {
    loanSchemeId: "E0250E39-F142-43B2-94E2-7CC731F4F258",
    schemeCode: "CGTMSE",
    schemeDescription:
      "Credit Guarantee Fund Trust for Micro and Small Enterprises",
    schemeDetails:
      "CGTMSE guarantees loans given to MSMEs by lending institutions like banks and NBFCs.\r\nThis guarantee encourages lenders to give credit to MSMEs without requiring collateral.\r\nCGTMSE helps make finance available to new entrepreneurs and underserved communities.",
    iconURL: "https://ibankeycdn.azureedge.net/cdnfiles/Logo/cgtmse-logo.png",
    govtWebSite: "https://www.cgtmse.in/Home/VS/3",
    isDefailt: false,
    key_takeaways:
      '["Collateral-free credit","Government-backed initiative","Boosts financial inclusion for MSMEs"]',
    sortOrder: 1,
    limit: 100000000.0,
  },
  {
    loanSchemeId: "7C68EADB-0A13-428C-A680-4482F1621E01",
    schemeCode: "SATAT",
    schemeDescription:
      "Sustainable Alternative Towards Affordable Transportation",
    schemeDetails:
      "SATAT scheme on Compressed Bio Gas (CBG) encourages entrepreneurs to set up CBG plants,\r\nproduce & supply CBG to Oil Marketing Companies (OMCs) for sale as automotive & industrial fuels.",
    iconURL: "https://ibankeycdn.azureedge.net/cdnfiles/Logo/Satat-logo.png",
    govtWebSite: "https://satat.co.in/satat/#/",
    isDefailt: false,
    key_takeaways:
      '["Collateral-free credit","Government-backed initiative","Boosts financial inclusion for MSMEs"]',
    sortOrder: 2,
    limit: 200000000.0,
  },
  {
    loanSchemeId: "3340907E-72F9-4C72-AD5B-79C4F920D178",
    schemeCode: "PMMY",
    schemeDescription: "Pradhan Mantri Mundra Yojana",
    schemeDetails:
      "Provides micro-financing to non-corporate, non-farm small/micro enterprises and 50% guarantee coverage for loans under MUDRA.",
    iconURL: "https://ibankeycdn.azureedge.net/cdnfiles/Logo/PMMY-Logo.png",
    govtWebSite: "https://www.mudra.org.in/",
    isDefailt: false,
    key_takeaways:
      '["Collateral-free credit","Government-backed initiative","Boosts financial inclusion for MSMEs"]',
    sortOrder: 3,
    limit: 2000000.0,
  },
  {
    loanSchemeId: "E0250E39-F142-43B2-94E2-7CC731F4F258",
    schemeCode: "SUI",
    schemeDescription: "Stand-Up India Scheme",
    schemeDetails:
      "Provides loans to women and SC/ST entrepreneurs for setting up greenfield enterprises.",
    iconURL: "https://ibankeycdn.azureedge.net/cdnfiles/Logo/SUI-logo.jpg",
    govtWebSite: "https://www.standupmitra.in/Home/SUISchemes",
    isDefailt: false,
    key_takeaways:
      '["Collateral-free credit","Government-backed initiative","Boosts financial inclusion for MSMEs"]',
    sortOrder: 4,
    limit: 10000000.0,
  },
];

window.addEventListener("load", () => {
  (window as any).AOS.init();
  const animationContainer = document.getElementById("lottie-container");
  const oneplatform= document.getElementById("oneplatform");
  const aiLottie= document.getElementById("aiLottie");
  const funLottie= document.getElementById("funLottie");
  const mangementLottie= document.getElementById("mangementLottie");
  const airobotLottie= document.getElementById("airobotLottie");
  const smeBtn = document.getElementById("smeBtn");
  const sme_modal = document.getElementById("sme_modal") as HTMLDialogElement;
  const sme_form = document.getElementById("sme_form") as HTMLFormElement;
  const sme_industries_options = document.getElementById(
    "industry"
  ) as HTMLDListElement;
  const sme_submit_btn = document.getElementById(
    "sme_submit_btn"
  ) as HTMLButtonElement;

  const govtSchemesOptions = document.getElementById(
    "govtScheme"
  ) as HTMLSelectElement;

  const smeWorker = new Worker(new URL("./smeWorker.ts", import.meta.url), {
    type: "module",
    name: "smeWorker",
  });
  const industryWorker = new Worker(
    new URL("./getIndustries.ts", import.meta.url),
    {
      type: "module",
      name: "industryWorker",
    }
  );

  industryWorker.postMessage(null);

  industryWorker.onmessage = ({ data }) => {
    if (Array.isArray(data) && data.length) {
      data.forEach((industry) => {
        const option = document.createElement("option");
        option.value = industry?.industryId;
        option.label = industry?.code;
        sme_industries_options.appendChild(option);
      });
    }
  };

  schems.forEach((schems) => {
    const option = document.createElement("option");
    option.innerText = schems.schemeCode;
    option.value = schems.loanSchemeId;
    govtSchemesOptions.appendChild(option);
  });

  setTimeout(() => {
    
    //@ts-ignore
    lottie.loadAnimation({
      container: animationContainer,
      renderer: "svg",
      loop: true,
      autoplay: true,
      path: "https://cdn.jsdelivr.net/gh/heisenpreet/ibankeyAssest@master/map.json",
    });
    //@ts-ignore
    lottie.loadAnimation({
      container: oneplatform,
      renderer: "svg",
      loop: true,
      autoplay: true,
      path: "https://cdn.jsdelivr.net/gh/heisenpreet/ibankeyAssest@master/Platform%20exchange.json",
    });
    //@ts-ignore
    lottie.loadAnimation({
      container: aiLottie,
      renderer: "svg",
      loop: true,
      autoplay: true,
      path: "https://cdn.jsdelivr.net/gh/heisenpreet/ibankeyAssest@master/AI%20intelligence.json",
    });
    //@ts-ignore
    lottie.loadAnimation({
      container: funLottie,
      renderer: "svg",
      loop: true,
      autoplay: true,
      path: "https://cdn.jsdelivr.net/gh/heisenpreet/ibankeyAssest@master/solidar-lottie.json",
    });
    //@ts-ignore
    lottie.loadAnimation({
      container: mangementLottie,
      renderer: "svg",
      loop: true,
      autoplay: true,
      path: "https://cdn.jsdelivr.net/gh/heisenpreet/ibankeyAssest@master/Management.json",
    });
    //@ts-ignore
    lottie.loadAnimation({
      container: airobotLottie,
      renderer: "svg",
      loop: true,
      autoplay: true,
      path: "https://cdn.jsdelivr.net/gh/heisenpreet/ibankeyAssest@master/Artificial%20Intelligence.json",
    });
  }, 0);
  

  if (smeBtn && sme_modal) {
    smeBtn.onclick = () => {
      sme_modal.showModal();
    };
  }

  sme_form.onsubmit = (event) => {
    event.preventDefault();
    sme_submit_btn.disabled = true;

    const values: Record<string, string> = {};
    const keys = [
      "companyName",
      "email",
      "industry",
      "enquire",
      "loanAmount",
      "govtScheme",
    ];
    const target = event.target as HTMLFormElement;

    keys.forEach((key) => {
      values[key] = target?.[key as keyof typeof target].value;
    });

    let loans = [];
    if (target["termloan"]?.checked) {
      loans.push(target["termloan"].value);
    }
    if (target["supplyChainFinance"]?.checked) {
      loans.push(target["supplyChainFinance"].value);
    }
    if (target["workingCapital"]?.checked) {
      loans.push(target["workingCapital"].value);
    }

    if (loans.length) {
      values["laonType"] = loans.join(",");
    } else {
      values["laonType"] = "00000000-0000-0000-0000-000000000000";
    }
    smeWorker.postMessage(values);

    const sendingPara = document.createElement("p");
    sendingPara.innerText = "sending...";
    sme_submit_btn.replaceChildren(sendingPara);

    function onSuccess() {
      sendingPara.innerText = "Submit Enquiry";
      target.reset();
      sme_modal.close();
      window.alert("Your enquire has been sent successfully");
      sme_submit_btn.disabled = false;
    }
    function onFailure() {
      sendingPara.innerText = "Submit Enquiry";
      target.reset();
      sme_modal.close();
      window.alert("Something went wrong! ");
      sme_submit_btn.disabled = false;
    }
    smeWorker.onmessage = ({ data }) => {
      if (data) {
        onSuccess();
      } else {
        onFailure();
      }
    };
    smeWorker.onerror = onFailure;
  };
});
